<template>
  <span class="tag">
    <slot />
  </span>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
  .tag {
    display: inline-flex;
    align-items: center;
    z-index: 2;	
    transform: translateY(-50%);
    background: lighten(red, 5%);
    box-shadow: 2px 2px 5px rgba(lighten(red, 5%), .6);
    border-bottom: 2px solid lighten(red, 3.5%);
    border-top: 2px solid lighten(red, 8.5%);
    border-radius: 4px;
    padding: 4px 8px;
    font-family: 'Poppins';
    font-size: 12px;
    font-weight: 700;
    color: #fff;

    svg { fill: #fff; width: 20px; margin-right: 5px }

    &.position--top-right {
      position: absolute;
      top: 0;
      right: 10px;
      transform: translateY(-50%);
    }
  }
</style>
